<template>
    <modal-component 
        :title="$helpers.trans('auth.registerModalTitle')" 
        :open="open" 
        @close="$emit('update:open', false)">

        <form-component 
            name="Login" 
            action="/register" 
            :spam-filter="false"
            @success="registrationComplete()">

            <div class="form-group">
                <label class="control-label">{{ $helpers.trans('auth.email') }}</label>
                <input type="email" required class="form-control" name="email" v-model="user.email">
                <span class="bar"></span>
                <div class="invalid-feedback"></div>
            </div>

            <div class="form-group">
                <label class="control-label">{{ $helpers.trans('auth.password') }}</label>
                <input type="password" required class="form-control" name="password" v-model="user.password">
                <span class="bar"></span>
                <div class="invalid-feedback"></div>
            </div>

            <div class="form-group">
                <label class="control-label">{{ $helpers.trans('auth.passwordConfirmation') }}</label>
                <input type="password" required class="form-control" name="password_confirmation" v-model="user.password_confirmation">
                <span class="bar"></span>
                <div class="invalid-feedback"></div>
            </div>

            <div class="form-group">
                <label class="control-label">{{ $helpers.trans('auth.firstname') }}</label>
                <input type="text" required class="form-control" name="firstname" v-model="user.firstname">
                <span class="bar"></span>
                <div class="invalid-feedback"></div>
            </div>

            <div class="form-group">
                <label class="control-label">{{ $helpers.trans('auth.lastname') }}</label>
                <input type="text" required class="form-control" name="lastname" v-model="user.lastname">
                <span class="bar"></span>
                <div class="invalid-feedback"></div>
            </div>

        </form-component>

        <div slot="footer" v-if="complete">
            <span class="btn btn-default" @click="$emit('update:open', false)">Close</span>
        </div>
    </modal-component>
</template>
<script>
import ModalComponent from '#app#/components/common/Modal.vue'
import FormComponent from '#app#/components/common/Form.vue'

export default {
    components: {
        ModalComponent,
        FormComponent
    },
    props: ['open'],
    data() {
        return {
            user: {
                email: null,
                password: null,
                password_confirmation: null,
                firstname: null,
                lastname: null,
            },

            complete: false,
        }
    },

    methods: {
        registrationComplete() {
            this.complete = true;
            this.user = {
                email: null,
                password: null,
                password_confirmation: null,
                firstname: null,
                lastname: null,
            };
        }
    }
}
</script>



// WEBPACK FOOTER //
// js/components/package/RF/Member/modals/Register.vue